import { Record } from 'immutable';

const BrowseSection = Record(
  {
    id: '',
    title: '',
    viewAll: '',
    viewAllAnalyticsToken: '',
    webUrl: '',
    items: [],
    sectionId: '',
    numOfSubsections: '',
    subsections: [],
    totalItems: '',
    totalPages: '',
    currentCount: '',
    fetchedPages: [],
    requestId: '',
  },
  'BrowseSection',
);

export default BrowseSection;
